export const getDateFormat = (dateFormat) => {
  if (dateFormat === 'YMD')
    return 'yyyy/MM/dd'
  else if (dateFormat === 'DMY')
    return 'dd/MM/yyyy'
  else
    return 'MM/dd/yyyy'
}

export const getDateTimeFormat = (dateFormat, timeFormat = 'h:mm aa') => {
  if (dateFormat === 'YMD')
    return 'yyyy/MM/dd' + ' ' + timeFormat
  else if (dateFormat === 'DMY')
    return 'dd/MM/yyyy' + ' ' + timeFormat
  else
    return 'MM/dd/yyyy' + ' ' + timeFormat
}

export const getDateUnixFormat = (format, timeFormat = 'h:mma') => {
  if (format === 'YMD') {
    return 'YYYY/MM/DD' + ' ' + timeFormat
  } else if (format === 'DMY') {
    return 'DD/MM/YYYY' + ' ' + timeFormat
  } else {
    return 'MM/DD/YYYY' + ' ' + timeFormat
  }
}
